import * as tslib_1 from "tslib";
import { ToasterComponent } from '../../../toasterComponent/toasterComponent';
import { ViewContainerRef, OnInit } from '@angular/core';
import { MDMService } from '../services/mdmService.service';
import { RoleAuthService } from '../services/roleAuthService.service';
var roleAuthorizationComponent = /** @class */ (function () {
    function roleAuthorizationComponent(roleAuthService, MDMAuthService, toastr, vcr) {
        this.roleAuthService = roleAuthService;
        this.MDMAuthService = MDMAuthService;
        this.toastr = toastr;
        this.vcr = vcr;
        this.accessDenied = false;
        this.loader = true;
        this.mainPage = true;
        this.isEdit = false;
        this.roleList = [];
        this.roleIdList = [];
        this.countMap = new Map();
        this.trackHides = null;
        this.roleId = [];
        this.pageNo = 1;
        this.pageSize = 10;
        this.toastr.setViewRef(this.vcr);
    }
    roleAuthorizationComponent.prototype.ngOnInit = function () {
        if (this.MDMAuthService.isBIAdmin) {
            this.loadData();
        }
        else {
            this.accessDenied = true;
        }
    };
    roleAuthorizationComponent.prototype.loadData = function () {
        var self = this;
        self.loadRoles().then(function () {
            //self.loadWidgetCounts();
        }, function (err) {
            console.error(err);
        });
    };
    roleAuthorizationComponent.prototype.loadRoles = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loader = true;
                        // let pageNo = 1;
                        // let pageSize = 10;
                        this.roleList = [];
                        this.roleIdList = [];
                        return [4 /*yield*/, this.roleAuthService.getRoleList(this.pageNo, this.pageSize)];
                    case 1:
                        res = _a.sent();
                        // res = JSON.parse(JSON.stringify(res));
                        this.roleList = res && res.content ? res.content : null;
                        this.totalPages = res.totalPages;
                        this.totalRoles = res.totalElements;
                        this.loader = false;
                        this.mainPage = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    // async loadWidgetCounts(){
    //     this.roleList.forEach(element => {
    //         this.roleIdList.push(element.id);
    //     });
    //     this.loader = true;
    //     this.roleCounts = await this.roleAuthService.getWidgetCount(this.roleIdList);
    //     this.setCountMap();
    //     this.loader = false;
    // }
    roleAuthorizationComponent.prototype.OnPageSizeChanged = function (event) {
        this.pageSize = event.target.value;
        this.loadRoles();
    };
    roleAuthorizationComponent.prototype.onPageChange = function (event) {
        this.pageNo = event;
        this.loadRoles();
    };
    roleAuthorizationComponent.prototype.setCountMap = function () {
        var _this = this;
        if (this.roleCounts) {
            var countArr = this.roleCounts;
            countArr.forEach(function (countObj) {
                _this.countMap.set(countObj.roleId, countObj.count);
            });
        }
    };
    roleAuthorizationComponent.prototype.clicked = function () {
        this.trackHides = null;
    };
    roleAuthorizationComponent.prototype.tableActions = function (value) {
        this.trackHides = (this.trackHides == value) ? null : value;
    };
    roleAuthorizationComponent.prototype.editRoles = function (id, name) {
        this.trackHides = null;
        //this.roleAuthService.setRoleId(id,name);
        this.roleId[0] = id;
        this.roleName = name;
        this.roleList = [];
        this.isEdit = true;
    };
    roleAuthorizationComponent.prototype.onEdit = function (event) {
        // this.toastr.setViewRef(this.vcr);
        this.loadData();
        this.isEdit = false;
    };
    return roleAuthorizationComponent;
}());
export { roleAuthorizationComponent };



// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/roleAuthorization.component.ts.pre-build-optimizer.js